<script>
	import {Bar, mixins as barChartMixins } from 'vue-chartjs';
    /*
        for reactive pupose we can use 'reactiveProp' from vue-charjs mixins
        for now we use watch option instead of 'reactiveProp' to control some 'undefined' errors
     */
	export default {
		extends: Bar,
        name: "BarChart",
		props: {
			options: {
				type: Object
			},
			chartData: {
				type: Object,
				required: true
			}
		},
		watch: {
			chartData(oldValue, newValue) {
				if (oldValue) this.renderChart(oldValue, this.options);
			},

			options: {
				handler(val) {
					this.renderChart(this.chartData, val);
				},
				deep: true
			}
		},

		mounted() {
            this.$nextTick(() => {
                this.renderChart(this.chartData, this.options);
            })
		}
	}
</script>

<style scoped>

</style>
